<template>
  <section class="faq-section">
    <div class="faq-section__inner">
      <h2 class="faq-section__title">{{ $lang.app.frequently_asked_questions }}</h2>


      <div class="faq-section__grid">

        <!-- Preschool FAQ -->
        <router-link to="/faq?type=PRESCHOOL" class="faq-card">
          <div class="faq-card__icon">
            <i class="bi-patch-question-fill"></i>
          </div>
          <div class="faq-card__body">
            <h3 class="faq-card__title">{{ $lang.app.preschool }}</h3>
            <p class="faq-card__desc">{{ $lang.app.preschool_faq_description }}</p>
          </div>
          <div class="faq-card__action">
            <span>{{ $lang.app.detailed_instructions }}</span>
            <i class="bi-arrow-right-circle-fill"></i>
          </div>
        </router-link>

        <!-- Regulatory framework -->
        <router-link to="/law" class="faq-card">
          <div class="faq-card__icon faq-card__icon--purple">
            <i class="bi-journal-text"></i>
          </div>
          <div class="faq-card__body">
            <h3 class="faq-card__title">{{ $lang.app.regulatory_legal_framework }}</h3>
            <p class="faq-card__desc">{{ $lang.app.regulatory_legal_framework_description }}</p>
          </div>
          <div class="faq-card__action">
            <span>{{ $lang.app.detailed_instructions }}</span>
            <i class="bi-arrow-right-circle-fill"></i>
          </div>
        </router-link>

      </div>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style scoped>
/* ───── Section ───── */
.faq-section {
  padding: 72px 0 80px;
  background: linear-gradient(160deg, #f0f4fb 0%, #e8eef8 100%);
}
.faq-section__inner {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 48px;
}

/* ───── Heading ───── */
.faq-section__title {
  text-align: center;
  font-size: 32px;
  font-weight: 800;
  color: #0a183c;
  margin: 0 0 12px;
  letter-spacing: -0.5px;
}
.faq-section__subtitle {
  text-align: center;
  font-size: 16px;
  color: #5a6a8a;
  margin: 0 0 52px;
}

/* ───── Grid ───── */
.faq-section__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px;
}

/* ───── Card ───── */
.faq-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #fff;
  border: 1px solid rgba(21, 101, 192, 0.1);
  border-radius: 20px;
  padding: 36px 32px 28px;
  text-decoration: none;
  box-shadow: 0 4px 24px rgba(10, 24, 60, 0.07);
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}
.faq-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(21, 101, 192, 0.14);
  border-color: rgba(21, 101, 192, 0.25);
}

/* ───── Icon ───── */
.faq-card__icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: linear-gradient(135deg, #1e88e5, #1565c0);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
  box-shadow: 0 8px 20px rgba(21, 101, 192, 0.35);
  flex-shrink: 0;
}
.faq-card__icon--purple {
  background: linear-gradient(135deg, #7c4dff, #512da8);
  box-shadow: 0 8px 20px rgba(81, 45, 168, 0.35);
}

/* ───── Body ───── */
.faq-card__body {
  flex: 1;
}
.faq-card__title {
  font-size: 20px;
  font-weight: 700;
  color: #0a183c;
  margin: 0 0 10px;
  line-height: 1.3;
}
.faq-card__desc {
  font-size: 15px;
  color: #5a6a8a;
  line-height: 1.65;
  margin: 0;
}

/* ───── Action row ───── */
.faq-card__action {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid rgba(21, 101, 192, 0.08);
  color: #1565c0;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.2px;
}
.faq-card__action i {
  font-size: 20px;
  margin-left: auto;
  transition: transform 0.2s;
}
.faq-card:hover .faq-card__action i {
  transform: translateX(4px);
}

/* ───── Responsive ───── */
@media screen and (max-width: 1100px) {
  .faq-section__inner {
    padding: 0 32px;
  }
}
@media screen and (max-width: 768px) {
  .faq-section {
    padding: 52px 0 60px;
  }
  .faq-section__inner {
    padding: 0 20px;
  }
  .faq-section__title {
    font-size: 26px;
  }
  .faq-section__subtitle {
    font-size: 15px;
    margin-bottom: 36px;
  }
  .faq-section__grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .faq-card {
    padding: 28px 24px 22px;
  }
}
@media screen and (max-width: 479px) {
  .faq-section__title {
    font-size: 22px;
  }
  .faq-card__icon {
    width: 54px;
    height: 54px;
    font-size: 24px;
    border-radius: 13px;
  }
  .faq-card__title {
    font-size: 18px;
  }
}
</style>
